// src/services/caseStudiesService.js
import apiClient from './apiClient.js'

export const caseStudiesService = {
    getCaseStudies(params = {}) {
        return apiClient.get('/case-studies', { params })
    },

    getCaseStudyBySlug(slug) {
        return apiClient.get(`/case-studies/${slug}`)
    },

    getCaseStudyCategories() {
        return apiClient.get('/case-studies/categories')
    },

    getCaseStudyIndustries() {
        return apiClient.get('/case-studies/industries')
    },

    createCaseStudy(data) {
        return apiClient.post('/case-studies', data)
    },

    updateCaseStudy(id, data) {
        return apiClient.put(`/case-studies/${id}`, data)
    },

    deleteCaseStudy(id) {
        return apiClient.delete(`/case-studies/${id}`)
    },
}